"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var context = _react.default.createContext({
  offsetHeight: 0,
  scrollHeight: 0,
  setTarget: function setTarget() {
    return 0;
  }
});

context.displayName = 'ScrollToBottomInternalContext';
var _default = context;
exports.default = _default;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9TY3JvbGxUb0JvdHRvbS9JbnRlcm5hbENvbnRleHQuanMiXSwibmFtZXMiOlsiY29udGV4dCIsIlJlYWN0IiwiY3JlYXRlQ29udGV4dCIsIm9mZnNldEhlaWdodCIsInNjcm9sbEhlaWdodCIsInNldFRhcmdldCIsImRpc3BsYXlOYW1lIl0sIm1hcHBpbmdzIjoiOzs7Ozs7O0FBQUE7Ozs7QUFFQSxJQUFNQSxPQUFPLEdBQUdDLGVBQU1DLGFBQU4sQ0FBb0I7QUFDbENDLEVBQUFBLFlBQVksRUFBRSxDQURvQjtBQUVsQ0MsRUFBQUEsWUFBWSxFQUFFLENBRm9CO0FBR2xDQyxFQUFBQSxTQUFTLEVBQUU7QUFBQSxXQUFNLENBQU47QUFBQTtBQUh1QixDQUFwQixDQUFoQjs7QUFNQUwsT0FBTyxDQUFDTSxXQUFSLEdBQXNCLCtCQUF0QjtlQUVlTixPIiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IFJlYWN0IGZyb20gJ3JlYWN0JztcblxuY29uc3QgY29udGV4dCA9IFJlYWN0LmNyZWF0ZUNvbnRleHQoe1xuICBvZmZzZXRIZWlnaHQ6IDAsXG4gIHNjcm9sbEhlaWdodDogMCxcbiAgc2V0VGFyZ2V0OiAoKSA9PiAwXG59KTtcblxuY29udGV4dC5kaXNwbGF5TmFtZSA9ICdTY3JvbGxUb0JvdHRvbUludGVybmFsQ29udGV4dCc7XG5cbmV4cG9ydCBkZWZhdWx0IGNvbnRleHQ7XG4iXX0=


//////////////////
// WEBPACK FOOTER
// ./~/react-scroll-to-bottom/lib/ScrollToBottom/InternalContext.js
// module id = 42
// module chunks = 0